export default Object.freeze({
  SendMessage: 1,
});
